/** @format */

import * as serviceWorker from "./serviceWorker";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";
import { setLoginFlag, setLoginUser } from "./redux/actions/login/loginAction";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import "./assets/scss/style.scss";
import "./assets/css/responsive.css";
import { history } from "./app/AppRouter";
import Spinner from "./components/spinner/spinner";
import ReduxToastr from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { subscribeToMember } from "./services/socketInstance";
import {
  getPermissions,
  getAllPermission,
  getsubAdminPermissions,
  unreadNotificationCountApi,
} from "./redux/actions/api/apiAction";
import {
  setPermissons,
  setStaffGurationFilter,
} from "./redux/actions/permissons/permissons";
import { createBrowserHistory } from "history";
import { decodeJWT } from "./components/package/utils";
const LazyApp = lazy(() => import("./app/AppRouter"));

const replaceHashPath = () => {
  const history = createBrowserHistory();
  const hash = history.location.hash;
  if (hash) {
    const path = hash.replace(/^#/, "");
    if (path) {
      history.replace(path);
    }
  }
};
replaceHashPath();

//Main JSX
const jsx = (
  <Provider store={store}>
    <Suspense
      fallback={
        <div className="d-flex vh-100 align-items-center justify-content-center ">
          <Spinner />
        </div>
      }
    >
      <LazyApp />
      <ReduxToastr
        timeOut={10000} // move this to constant.js
        newestOnTop={false}
        preventDuplicates
        position="top-center"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        // progressBar
        closeOnToastrClick
      />
    </Suspense>
  </Provider>
);

let hasRendered = false;
const renderApp = async () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById("root"));
    hasRendered = true;
  }
};

serviceWorker.unregister();

const renderLogin = () => {
  store.dispatch(setLoginFlag(false));
  localStorage.removeItem("connectToFitGymPanelUser");
  renderApp();

  if (
    window.location.pathname === "/reset-password" ||
    window.location.pathname === "/reset-password" ||
    window.location.pathname === "/redirect/supergymadmin" ||
    window.location.pathname === "/pos/login" ||
    window.location.pathname === "/pos"
  ) {
  } else {
    history.push("/");
  }
};

const tryLogin = async () => {
  try {
    if (
      window.location.pathname === "/connect-to-fit/website/reset-password" ||
      window.location.pathname === "/connect-to-fit/website/reset-password/"
    ) {
      localStorage.removeItem("connectToFitGymPanelUser");
      renderApp();
    }
    const login = localStorage.getItem("connectToFitGymPanelUser");
    if (login) {
      const loginObject = JSON.parse(login);
      store.dispatch(setLoginUser(loginObject));
      store.dispatch(unreadNotificationCountApi());
      if (loginObject.role === "STAFF") {
        let allPermission = await getAllPermission();
        let staffPermissons = await getPermissions(loginObject.id);
        let permissons = { ...allPermission, ...staffPermissons };
        store.dispatch(setPermissons(permissons));
        if (store.getState().permissions.permissions["S-SHW-DASH-1M"]) {
          store.dispatch(setStaffGurationFilter("1M"));
        } else if (store.getState().permissions.permissions["S-SHW-DASH-1W"]) {
          store.dispatch(setStaffGurationFilter("1W"));
        } else if (store.getState().permissions.permissions["S-SHW-DASH-3D"]) {
          store.dispatch(setStaffGurationFilter("3D"));
        }
      }
      if (loginObject?.isSuperGymAdmin) {
        const decodedData = decodeJWT(loginObject?.token);
        await store.dispatch(getsubAdminPermissions(decodedData?.id));
        if (store.getState().permissions.subAdminPermissions["S-SHW-DASH-1M"]) {
          store.dispatch(setStaffGurationFilter("1M"));
        } else if (
          store.getState().permissions.subAdminPermissions["S-SHW-DASH-1W"]
        ) {
          store.dispatch(setStaffGurationFilter("1W"));
        } else if (
          store.getState().permissions.subAdminPermissions["S-SHW-DASH-3D"]
        ) {
          store.dispatch(setStaffGurationFilter("3D"));
        }
      }

      store.dispatch(setLoginFlag(true));
      subscribeToMember(
        `${loginObject.id}${loginObject.role === "GYM" || loginObject.role === "STAFF" ? "G" : "T"
        }`
      );
      renderApp();
      // if (
      //   loginObject.role === 'GYM'
      // ) {
      //   history.push('/gym-panel/dashboard');
      // }
    } else {
      // Don't redirect if we're on POS routes
      if (window.location.pathname.startsWith("/pos")) {
        renderApp();
      } else {
        renderLogin();
      }
      // history.push('/login');
    }
  } catch (e) {
    // Don't redirect if we're on POS routes
    if (window.location.pathname.startsWith("/pos")) {
      renderApp();
    } else {
      renderLogin();
    }
  }
};

tryLogin();
